module.exports = __webpack_public_path__ + "img/canadaMap.a4bc8cab.png";